export const projectStatusMap = {
    "in progress": {
        tag: "tag--blue",
        iconName: "hour-glass",
    },
    completed: {
        tag: "tag--green",
        iconName: "earnings",
    },
    blocked: {
        tag: "tag--red",
        iconName: "close",
    },
    pending: {
        tag: "tag--pink",
        iconName: "timer-solid",
    },
    "awaiting feedback": {
        tag: "tag--grey",
        iconName: "folder-open",
    },
    "to do": {
        tag: "tag--purple-2",
        iconName: "layer",
    },
    "requires fixes": {
        tag: "tag--red",
        iconName: "settings",
    },
    "archived": {
        tag: "tag--cornsilk",
        iconName: "folder-open",
    },
};

export const projectTypeMap = {
    "paid": {
        tag: "tag--green",
        iconName: "money",
    },
    "not paid": {
        tag: "tag--pink",
        iconName: "balance",
    },
};

export const paymentStatusMap = {
    "paid": {
        tag: "tag--green",
        iconName: "money",
    },
    "overdue": {
        tag: "tag--blue",
        iconName: "balance",
    },
    "draft": {
        tag: "tag--pink",
        iconName: "balance",
    },

    "failed": {
        tag: "tag--red",
        iconName: "balance",
    },
};

export const invoiceStatusMap = {
    draft: {
        tag: "tag--blue",
        iconName: "layer",
    },
    issued: {
        tag: "tag--purple",
        iconName: "close",
    },
    pending: {
        tag: "tag--cornsilk",
        iconName: "close",
    },
    "fully paid": {
        tag: "tag--green",
        iconName: "money",
    },
    overdue: {
        tag: "tag--red",
        iconName: "alarm",
    },
    failed: {
        tag: "tag--pink",
        iconName: "receipt",
    },
    rejected: {
        tag: "tag--grey",
        iconName: "close",
    },
    "partially paid": {
        tag: "tag--purple-2",
        iconName: "signal",
    },
};

export const clientStatusMap = {
    active: {
        tag: "tag--green",
        iconName: "signal",
    },
    inactive: {
        tag: "tag--grey",
        iconName: "no-signal",
    },
    "onboarding": {
        tag: "tag--blue",
        iconName: "map-pin",
    },
    "potential lead": {
        tag: "tag--cornsilk",
        iconName: "user",
    },
    "reached out": {
        tag: "tag--purple",
        iconName: "phone",
    },
    "archived": {
        tag: "tag--pink",
        iconName: "close",
    },
};

export const integrationMap = {
    "enabled": {
        tag: "tag--green",
        iconName: "money",
    },
    "disabled": {
        tag: "tag--pink",
        iconName: "balance",
    },
    "none": {
        tag: "tag--blue",
        iconName: "balance",
    },
};

export const meetingStatusMap = {
    confirmed: {
        tag: "tag--blue",
        iconName: "signal",
    },
    needsAction: {
        tag: "tag--cornsilk",
        iconName: "no-signal",
    },
    "cancelled": {
        tag: "tag--pink",
        iconName: "close",
    },
};

export const INVOICE_STATUSES = ["blocked", "draft", "overdue", "fully paid", "issued", "rejected", "partially paid"];

export const INVOICE_UPDATE_STATUSES = ["blocked", "fully paid", "rejected", "partially paid", "overdue"];

export const projectFilterStatuses = ["blocked", "completed", "in progress", "pending", "awaiting feedback", "requires fixes", "to do", "archived"];

export const clientFilterStatuses = ["active", "archived", "inactive", "onboarding", "potential lead", "reached out"];

export const invoiceFilterStatuses = ["rejected", "fully paid", "issued", "blocked", "overdue", "draft", "partially paid", "failed"];

export const priorities = ["low", "medium", "high", "highest"];

export const taskStatus = [
    {
        name: "Completed",
        value: false,
    },
    {
        name: "Completed",
        value: true,
    },
];

export const CLIENT_STATUSES = ["active", "inactive", "onboarding", "potential lead", "reached out"];

export const integrationProvidersLogos = {
    "calendly": "https://cdn.brandfetch.io/idbJpTKFPT/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B",
    "google calendar": "",
};

export const rateTypeMap = {
    "per-project": "tag--purple",
    "yearly": "tag--blue",
    "one-off": "tag--cornsilk",
    "monthly": "tag--purple",
    "hourly": "tag--green",
    "weekly": "tag--pink",
};

export const projectDeadlineCopyMap = {
    "due soon": {
        tag: "tag--blue",
        iconName: "layer",
    },
    due: {
        tag: "tag--purple",
        iconName: "close",
    },
    overdue: {
        tag: "tag--pink",
        iconName: "receipt",
    },
};

export const MAX_COUNT_BY_FEATURES = {
    free: {
        reminderCount: 0,
        downloadCount: 0,
        uploadCount: 0,
        sentEmailsCount: 0,
    },
    standard: {
        reminderCount: 1000,
        downloadCount: 1000,
        uploadCount: 1000,
        sentEmailsCount: 1000,
    },
    plus: {
        reminderCount: undefined,
        downloadCount: undefined,
        uploadCount: undefined,
        sentEmailsCount: undefined,
    },
};

export const MAX_COUNT_BY_COLLECTIONS = {
    free: {
        clients: {
            create: 2,
        },
        projects: {
            create: 2,
            timeTracking: undefined,
        },
        invoices: {
            create: 2,
        },
        meetings: {
            create: undefined,
        },
        rateCards: {
            create: 1,
        },
        tags: {
            create: undefined,
        },
        checkIns: {
            create: undefined,
        },
    },
    standard: {
        clients: {
            create: 20,
        },
        projects: {
            create: 20,
            timeTracking: 10,
        },
        invoices: {
            create: 20,
        },
        meetings: {
            create: 100,
        },
        rateCards: {
            create: 0,
        },
        tags: {
            create: undefined,
        },
        meetings: {
            create: 100,
        },
        checkIns: {
            create: undefined,
        },
    },
    plus: {
        clients: {
            create: 0,
        },
        projects: {
            create: 0,
            timeTracking: 0,
        },
        invoices: {
            create: 0,
        },
        meetings: {
            create: 0,
        },
        rateCards: {
            create: 0,
        },
        meetings: {
            create: 0,
        },
        checkIns: {
            create: 0,
        },
    },
};

export const MEETING_STATUSES = ["confirmed", "needsAction", "cancelled"];

export const ALLOWED_COUNTRIES = ["Nigeria", "Ghana"];

export const COUNTRY_RESTRICTION_ENCODING = {
    "hjbhuksb": true,
    "dknkqlp": false,
};